<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="empty-content"
    :class="cn('mt-3 flex w-full min-w-0 max-w-sm flex-col items-center gap-4 text-sm', props.class)"
  >
    <slot />
  </div>
</template>
